import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DealModel, ProfileModel } from '@app/core/models';
import { EventsService, StorageService } from '@app/core/services';

@Component({
  selector: 'app-your-coupons',
  templateUrl: './your-coupons.component.html',
  styleUrls: ['./your-coupons.component.scss'],
})
export class YourCouponsComponent implements OnInit, OnDestroy {
  @Input() wlMode = false;
  @Input() boxBtnMode = false;
  @Input() opened = false;

  @Output()
  toggleMenu: EventEmitter<boolean | void> = new EventEmitter();

  count = 0;
  activeCoupons: Array<DealModel> = [];
  redeemedCoupons: Array<DealModel> = [];

  private profile: ProfileModel;

  private destroy$: Subject<void> = new Subject();

  constructor(
    private storageService: StorageService,
    private eventsService: EventsService,
  ) {}

  ngOnInit(): void {
    this.initScreen();
    this.eventsService.openYourCoupons$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.toggleMenu.next(value);
      });

    this.eventsService.couponPurchaseComplete$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.initScreen();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  openPopup(event: MouseEvent): void {
    event.stopPropagation();
    this.toggleMenu.next();
  }

  private initScreen(): void {
    this.profile = this.storageService.PROFILE;
    this.count = 0;
    for (const coupon of this.profile.deals) {
      if (coupon.verifiedCount < coupon.notVerifiedCount) {
        for (let i = 0; i < coupon.notVerifiedCount; i++) {
          ++this.count;
          this.activeCoupons.push(coupon);
        }
      } else {
        for (let i = 0; i < coupon.verifiedCount; i++) {
          ++this.count;
          this.redeemedCoupons.push(coupon);
        }
      }
    }
  }
}
